import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const agregarMotivoCancelacion = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.MOTIVO_CANCELACION.ADD}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default agregarMotivoCancelacion;